<template>
  <v-layout column>
    <v-flex xs12 class="text-xs-center" mt-5>
      <h3>Error 404</h3>
      <h5>Oops, looks like your link is incorrect</h5>
    </v-flex>
  </v-layout>
</template>

<script>
export default {}
</script>



// WEBPACK FOOTER //
// src/components/NotFound.vue